<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>


export default {
  name: 'app',
//   mounted() {
// 	  this.$router.push({path:"index"})
//   }
}
</script>


<style>
@import '../src/fonts/font.css';
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  overflow-x: hidden;
  min-height: 100vh;
}
html, body {
  overflow-x: hidden;
  width: 100%;
  min-height: 100vh;
}
.v-application, .v-application--wrap, .v-main, .v-main__wrap, .v-content {
  min-height: 100vh;
  overflow-x: hidden;
}
.logo {
	border: 0;
	box-shadow: 0;
	width:16.67vw;
	transition: all 0.5s;
	-webkit-transition: all 0.5s;
}
.logo:hover {
	transform: scale(0.9);
	-webkit-transform: scale(0.9);
}
.logombz {
	border: 0;
	box-shadow: 0;
	width:10vw;
	transition: all 0.5s;
	-webkit-transition: all 0.5s;
}
.logombz:hover {
	transform: scale(0.9);
	-webkit-transform: scale(0.9);
}
.logonyu {
	border: 0;
	box-shadow: 0;
	width:10vw;
	transition: all 0.5s;
	-webkit-transition: all 0.5s;
}
.logonyu:hover {
	transform: scale(0.9);
	-webkit-transform: scale(0.9);
}
.index-gallery {
	z-index: 1;
}
.index-topbar {
  min-width: 1000px;
	z-index: 2;
}
@media (max-width: 960px) {
  .index-topbar {
    min-width: unset;
    flex-wrap: wrap;
    padding: 8px 12px;
  }
  .index-topbar .v-toolbar__content {
    flex-wrap: wrap;
  }
  .index-topbar .v-toolbar__items {
    flex: 1 1 100%;
    justify-content: space-around;
    flex-wrap: wrap;
    padding-top: 8px;
  }
  .index-topbar .v-toolbar__items .v-btn {
    font-size: 1rem !important;
    min-width: auto;
    padding: 0 8px !important;
  }
  .logo {
    width: 40vw;
    max-width: 180px;
    margin: 4px auto;
  }
  .logombz,
  .logonyu {
    width: 26vw;
    max-width: 120px;
    margin: 4px auto;
  }
}
@media (max-width: 600px) {
  .index-topbar .v-toolbar__items {
    justify-content: center;
  }
  .index-topbar .v-toolbar__items .v-btn {
    font-size: 0.95rem !important;
  }
}
</style>
